import { useTranslation } from 'react-i18next'
import { Navbar } from '@/components/ui/navbar'
import { Seo } from '@/components/seo/seo'
import { Hero } from '@/components/landing/hero'
import { ProblemSolution } from '@/components/landing/problem-solution'
import { Features } from '@/components/landing/features'
import { HowItWorks } from '@/components/landing/how-it-works'
import { TargetUsers } from '@/components/landing/target-users'
import { FinalCta } from '@/components/landing/final-cta'
import { Footer } from '@/components/landing/footer'

export function LandingPage() {
  const { t } = useTranslation()
  return (
    <div className="min-h-screen bg-background">
      <Seo title={t('seo.landing.title')} description={t('seo.landing.description')} path="/" />
      <Navbar />
      <main>
        <Hero />
        <ProblemSolution />
        <Features />
        <HowItWorks />
        <TargetUsers />
        <FinalCta />
      </main>
      <Footer />
    </div>
  )
}
